module.exports = __webpack_public_path__ + "media/newstyle/images/itau-112de8d1eb87bc4ccbf3ad3665c39d8a.svg";